import { Api } from "../Api";

export const postAdicionaBlackList = async (e) => {
  const { data } = await Api.post("/blacklist/cartao/bloquear", e);
  return data;
};

export const getConsultaBlackList = async (e) => {
  const { data } = await Api.get(`/blacklist/cartao/consultar/${e.usuario_id}/${e.cartao_primeiro}/${e.cartao_ultimo}`);
  return data;
};

export const getDocumentoBlackList = async (documento) => {
  const { data } = await Api.get(`/blacklist/pesquisar-lista-negra/${documento}`);
  return data;
};
